import { render, staticRenderFns } from "./StylingProcess.vue?vue&type=template&id=2c0af76b&scoped=true"
import script from "./StylingProcess.vue?vue&type=script&lang=js"
export * from "./StylingProcess.vue?vue&type=script&lang=js"
import style0 from "./StylingProcess.vue?vue&type=style&index=0&id=2c0af76b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0af76b",
  null
  
)

export default component.exports